import { Checkbox } from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import React, { FormEvent } from 'react'
import { useRange, useToggleRefinement } from 'react-instantsearch'

import sessionStore from '@/stores/sessionStore'
import { hasStemsAccess } from '@/utils/hasStemsAccess'

import CheckboxList from '../CheckboxList/CheckboxList'
import CheckboxListItem from '../CheckboxListItem/CheckboxListItem'

const MixesAndStems = (
	props: React.DetailedHTMLProps<
		React.HTMLAttributes<HTMLUListElement>,
		HTMLUListElement
	>
): JSX.Element => {
	const { t } = useTranslation(['search'])

	const user = sessionStore((state) => state.session?.user)

	const showStemsCheckbox = hasStemsAccess(user)

	const { start, range, refine: setRange } = useRange({ attribute: 'Mix' })
	const { max } = range

	const isHidingMixes = start[1] === 1

	const { value, refine } = useToggleRefinement({ attribute: 'HasStems' })

	const toggleMixes = (event: FormEvent): void => {
		const hideMixes = (event.target as HTMLInputElement).checked

		setRange([1, hideMixes ? 1 : max])
	}

	const toggleStems = (event: FormEvent): void => {
		refine({ isRefined: !(event.target as HTMLInputElement).checked })
	}

	return (
		<CheckboxList {...props}>
			<CheckboxListItem data-testid="hide-mix-item">
				<Checkbox
					checked={isHidingMixes}
					label={t('toggle-mixes')}
					name="mixes"
					onChange={toggleMixes}
				/>
			</CheckboxListItem>
			{showStemsCheckbox && (
				<CheckboxListItem data-testid="hide-stems-item">
					<Checkbox
						checked={value.isRefined}
						label={t('toggle-stems')}
						name="stems"
						onChange={toggleStems}
					/>
				</CheckboxListItem>
			)}
		</CheckboxList>
	)
}

export default MixesAndStems
